import service from '@/services/auth';

const LOGIN = 'LOGIN';
const LOGOUT = 'LOGOUT';

export default {
  namespaced: true,
  state: () => ({
    isChecked: false,
    user: null,
  }),
  getters: {
    isAuthorized: state => state.isChecked && Boolean(state.user),
    checkPermission: state => (
      permission => state.user
        && Array.isArray(state.user.permissions)
        && state.user.permissions.includes(permission)
    ),
  },
  actions: {
    async check ({ commit }) {
      try {
        const user = await service.check();

        if (user) {
          return commit(LOGIN, user);
        }

        commit(LOGOUT);
      } catch (e) {
        commit(LOGOUT);
      }
    },
    async login ({ commit }, credintails) {
      const user = await service.login(credintails);

      if (user) {
        commit(LOGIN, user);
      }
    },
    async logout ({ commit }) {
      const succeed = await service.logout();

      if (succeed) {
        commit(LOGOUT);
      }
    },
  },
  mutations: {
    [LOGIN] (state, user) {
      state.isChecked = true;
      state.user = user;
    },
    [LOGOUT] (state) {
      state.isChecked = true;
      state.user = null;
    },
  },
};
